import * as z from "zod/v4";
import {
  getSelfServeOnboardingTimeSeries,
  selfServeOnboardingTimeSeriesSchema,
} from "../onboardings/get-self-serve-onboarding-time-series";
import { onboardingV2AnalyticsProductInputSchema } from "./analytics-product-id";

export const getOnboardingsV2TimeSeries = {
  name: "getOnboardingsV2TimeSeries" as const,
  input: z.intersection(
    getSelfServeOnboardingTimeSeries.input,
    onboardingV2AnalyticsProductInputSchema,
  ),
  output: selfServeOnboardingTimeSeriesSchema,
};

export type GetOnboardingsV2TimeSeriesInput = z.infer<
  typeof getOnboardingsV2TimeSeries.input
>;
export type GetOnboardingsV2TimeSeriesOutput = z.infer<
  typeof getOnboardingsV2TimeSeries.output
>;
